<template>
  <exo-help-dialog title="Modulation/Coding type">
    <p>
      When defining a RF link, a form of modulation must be chosen to interpret
      the signal. Additionally, a forward error correction (FEC) decoder may
      also be employed. A combination of a modulation and a coding type result
      in a curve that associates a bit error rate (BER), which corresponds to
      the number of bit errors per total bits transmitted, to a theoretical
      value of signal to noise ratio (or Eb/N0). The modulation/coding type
      selection then implies a selection of both the modulation and coding
      methods employed, as well as the selection of the operating point (which
      BER desired, implying a theoretical required Eb/N0). In addition to the
      default available options, you may also choose a custom type, where you
      may directly input the bit error rate and the theoretical signal to noise
      ratio. An additional loss can also be introduced, to take into
      consideration errors in the demodulation hardware or software. The
      required signal to noise ratio used in the link margin calculation will
      then be the sum of the theoretical Eb/N0 and the implementation loss
      estimate.
    </p>
    <p>
      The link margin is then given (in
      <katex-element expression="dB" />) by:
    </p>
    <p>
      <katex-element
        expression="\mathrm{Margin} = \left [ E_b/N_0 \right ]_{received} - \left [ E_b/N_0 \right ]_{required}"
      />
    </p>
    <p>
      <katex-element
        expression="\mathrm{Margin} =  \left [ E_b/N_0 \right ]_{received} - \left [ E_b/N_0 \right ]_{theoretical} - L_{implementation} "
      />
    </p>
    <p>
      with
      <katex-element expression="\left [ E_b/N_0 \right ]_{theoretical}" />
      being the theoretical Eb/N0 for the chosen Modulation/Coding type at the
      chosen BER, <katex-element expression="L_{implementation}" /> being the
      implementation loss associated to the Modulation/Coding and
      <katex-element expression="\left [ E_b/N_0 \right ]_{received}" />
      being the energy per bit to noise power density ratio actually received.
    </p>
    <tooltipEquationEbN0 />
  </exo-help-dialog>
</template>

<script>
import tooltipEquationEbN0 from './tooltipEquationEbN0.vue'
export default {
  name: 'tooltipModCod',
  components: {
    tooltipEquationEbN0
  }
}
</script>
